import axios from "../../api/axiosInstance";
/**
 * dmsApi — frontend wrapper for /api/dms/* endpoints.
 *
 * Requires axios to be configured with auth header (most apps have
 * an axiosInstance — adjust the import above if yours uses a custom
 * instance, e.g.:  import axios from "../../api/axiosInstance"
 *
 * The relative URL "/api/dms/file-token" goes through whatever proxy
 * the dev server / reverse proxy is configured for. Same path your
 * other axios calls already use successfully.
 */

/**
 * Issue a single-use file token.
 *
 * @param {object} input
 * @param {string} input.ref_type   e.g. 'gate_entry_doc_id', 'paperless_doc_id'
 * @param {string} input.ref_id     the actual reference value
 * @param {string} input.emp_id     operator id
 * @returns {Promise<{ok: boolean, token?: string, url?: string,
 *                    expires_at?: number, filename?: string,
 *                    paperless_id?: number, error?: string, detail?: string}>}
 */
export const issueFileToken = async ({ ref_type, ref_id, emp_id }) => {
  const r = await axios.post("/api/dms/file-token", {
    ref_type,
    ref_id,
    emp_id,
  });
  return r.data;
};

/**
 * Compose the full URL for the file endpoint, optionally with PDF
 * Open Parameters for page/zoom (record-level navigation).
 *
 * @param {string} baseUrl   e.g. "/api/dms/file?t=abc123"
 * @param {object} [opts]
 * @param {number} [opts.page]    1-based page number (e.g. 2 → "#page=2")
 * @param {string} [opts.zoom]    e.g. "100" (percent), "page-fit", "page-width"
 * @param {string} [opts.view]    e.g. "FitH", "FitV", "FitB"
 * @returns {string}
 */
export const buildFileUrl = (baseUrl, opts = {}) => {
  if (!baseUrl) return baseUrl;
  const frags = [];
  if (opts.page) frags.push(`page=${opts.page}`);
  if (opts.zoom) frags.push(`zoom=${opts.zoom}`);
  if (opts.view) frags.push(`view=${opts.view}`);
  if (frags.length === 0) return baseUrl;
  // PDF Open Parameters use # fragment
  const sep = baseUrl.includes("#") ? "&" : "#";
  return `${baseUrl}${sep}${frags.join("&")}`;
};
